import { composer } from '../../../../../component-decorators/composer';
import React, { useEffect } from 'react';
import s from '../solution-rate-reviews.scss';
import { ModalNames } from '../../../../modals/modals';
import { SolutionPageCtx } from '../../..';
import { Heading, Box, Text, TextButton } from '@wix/design-system';
import { BlockReviewsHelper } from './block-reviews-helper';
import { biLogger } from '../../../../../bi';
import { useConfigContext } from '../../../../../config-context';
import { appMarketReviewAppNotInstalledAlert } from '@wix/bi-logger-market/v2';

export const NoReviews = composer()
  .withTranslation()
  .withMarketplaceStore()
  .withExperiments()
  .compose((props) => {
    const [isHelperOpen, setOpenHelper] = React.useState(false);
    const textNoReviews = 'solution.page.noReviewsYet';
    const { isMobile } = useConfigContext();

    const openModal = (app) => {
      if (props.isEligibleForReviews === false) {
        if (!isHelperOpen) {
          biLogger.report(
            appMarketReviewAppNotInstalledAlert({
              app_id: app?.baseInfo.id,
            }),
          );
        }
        if (!isMobile) {
          setOpenHelper(!isHelperOpen);
        } else {
          props.marketplaceStore.openModal(ModalNames.BLOCK_ADD_REVIEW_MOBILE, {
            app,
            closeModal: () => props.marketplaceStore.closeAllModals(),
          });
        }
      } else {
        props.marketplaceStore.openModal(ModalNames.RATE_APP, {
          app,
          closeModal: () => props.marketplaceStore.closeAllModals(),
        });
      }
    };

    useEffect(() => {
      if (isHelperOpen) {
        setOpenHelper(false);
      }
    }, [props.appId]);

    return (
      <div data-testid="no-reviews">
        <Box direction="vertical">
          <div className={s.noReviewsTitle}>
            <Heading appearance="H2">
              {props.t('solution.page.noReviewsYetTitle')}
            </Heading>
          </div>
          <Text>
            {props.t(textNoReviews)}
            <SolutionPageCtx.Consumer>
              {(value) => (
                <TextButton
                  onClick={() => openModal(value.app)}
                  dataHook="add-review"
                >
                  <BlockReviewsHelper
                    app={value?.app}
                    opened={isHelperOpen}
                    target="solution.page.reviews.empty.addReview"
                  />
                </TextButton>
              )}
            </SolutionPageCtx.Consumer>
          </Text>
        </Box>
      </div>
    );
  });
